export default __webpack_public_path__ + "static/media/logo.475801f5.svg";